import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { TutorialLibrary, TutorialPlaylist, TutorialVideoItem } from "../models/tutorials.model"

export enum TutorialId {
  Popup = 'popups',
  SocialProof = 'social-proof-notifications',
  AbTesting = 'ab-testing',
  Upsell = 'one-click-upsell',
  Other = 'other',
  Email = 'email',
}

@Injectable()
export class TutorialsService {
  public currentPlaylist$: BehaviorSubject<TutorialPlaylist> = new BehaviorSubject<TutorialPlaylist>(null)
  public currentVideo$: BehaviorSubject<TutorialVideoItem> = new BehaviorSubject<TutorialVideoItem>(null)
  public returnURL: string
  public readonly BLOG_POSTS = {
    [TutorialId.Popup]: [
      {
        title: 'Setting Up the Fortune Wheel or Spin Wheel',
        titleKey: 'tutorials_page.blog_fortune_wheel',
        thumb: '',
        url: 'https://help.one.store/en/article/setting-up-the-fortune-wheel-or-spin-wheel-1hitxjt/',
      },
      {
        title: 'Setting up a Traditional Pop up (With Reward)',
        titleKey: 'tutorials_page.blog_traditional_popup_reward',
        thumb: '',
        url: 'https://help.one.store/en/article/setting-up-a-traditional-popup-with-reward-uyvxds/',
      },
      {
        title: 'Setting up a Traditional Pop up (Without Reward)',
        titleKey: 'tutorials_page.blog_traditional_popup_no_reward',
        thumb: '',
        url: 'https://help.one.store/en/article/setting-up-a-traditional-popup-without-reward-1kgujb2/',
      },
      {
        title: 'Display Rules for Pop up Campaigns',
        titleKey: 'tutorials_page.blog_display_rules',
        thumb: '',
        url: 'https://help.one.store/en/article/display-rules-for-popup-campaigns-nnqgki/',
      },
      {
        title: 'Opt-in Pop ups Triggers',
        titleKey: 'tutorials_page.blog_optin_triggers',
        thumb: '',
        url: 'https://help.one.store/en/article/opt-in-popups-triggers-ogn1dl/',
      },
    ],
    [TutorialId.Upsell]: [
      {
        title: 'One Click Upsell',
        titleKey: 'tutorials_page.blog_one_click_upsell',
        thumb: '',
        url: 'https://help.one.store/en/article/one-click-upsell-tjronx/',
      },
      {
        title: 'How does the Priority work in the One Click Upsell?',
        titleKey: 'tutorials_page.blog_upsell_priority',
        thumb: '',
        url: 'https://help.one.store/en/article/how-does-the-priority-work-in-the-one-click-upsell-1j877yl/',
      }
    ],
    [TutorialId.SocialProof]: [
      {
        title: 'Using Functions in Templates',
        titleKey: 'tutorials_page.blog_templates_functions',
        thumb: '',
        url: 'https://help.one.store/en/article/using-functions-in-templates-6huyvs/',
      },
      {
        title: 'Customize the Recent Activity Notification',
        titleKey: 'tutorials_page.blog_customize_recent_activity',
        thumb: '',
        url: 'https://help.one.store/en/article/customize-the-recent-activity-notification-15bdz0l/',
      },
    ],
    [TutorialId.Email]: [
      {
        title: 'Setting up a Custom Sending Email Address',
        titleKey: 'tutorials_page.blog_custom_sending_address',
        thumb: '',
        url: 'https://help.one.store/en/article/setting-up-a-custom-sending-email-address-1hbq4k7/',
      },
      {
        title: 'Saving Email Blocks or Transferring Email Templates',
        titleKey: 'tutorials_page.blog_email_templates_transfer',
        thumb: '',
        url: 'https://help.one.store/en/article/saving-email-blocks-or-transferring-email-templates-lvwnd0/',
      },
      {
        title: 'Email Spam Complaint Rate and Why It Matters',
        titleKey: 'tutorials_page.blog_spam_complaint_rate',
        thumb: '',
        url: 'https://help.one.store/en/article/email-spam-complaint-rate-and-why-it-matters-wpdq75/',
      },
      {
        title: 'Remove the Preview Text From Emails',
        titleKey: 'tutorials_page.blog_remove_preview_text',
        thumb: '',
        url: 'https://help.one.store/en/article/remove-the-preview-text-from-emails-1hnulrp/',
      },
      {
        title: 'Adding or Customizing an Unsubscribe Link',
        titleKey: 'tutorials_page.blog_unsubscribe_link',
        thumb: '',
        url: 'https://help.one.store/en/article/adding-or-customizing-an-unsubscribe-link-13aotb0/',
      },
      {
        title: 'How Revenue Attribution works for Email Campaigns',
        titleKey: 'tutorials_page.blog_revenue_attribution',
        thumb: '',
        url: 'https://help.one.store/en/article/how-revenue-attribution-works-for-email-campaigns-1f1lh6c/',
      },
      {
        title: 'Email Bounce Rate and Why It Matters',
        titleKey: 'tutorials_page.blog_bounce_rate',
        thumb: '',
        url: 'https://help.one.store/en/article/email-bounce-rate-and-why-it-matters-17gafl4/',
      },
      {
        title: 'Send Emails to Segments in Shopify',
        titleKey: 'tutorials_page.blog_shopify_segments',
        thumb: '',
        url: 'https://help.one.store/en/article/send-emails-to-segments-in-shopify-1dpsu5t/',
      },
    ],
    [TutorialId.AbTesting]: [
      {
        title: 'How to create A/B tests',
        titleKey: 'tutorials_page.blog_ab_tests',
        thumb: '',
        url: 'https://help.one.store/en/article/how-to-create-ab-tests-with-opt-in-pop-ups-170brbh/',
      },
    ],
  }

  public library: TutorialLibrary = {
    playlists: [
      // POPUPS
      {
        title: 'Pop Ups',
        titleKey: 'tutorials_page.playlist_popups',
        id: TutorialId.Popup,
        thumbNailSrc: '/app_assets/video-gallery/fw-thumbnail.png',
        videos: [
          {
            id: 'IvJ4nSIHrYA',
            title: 'Spin Wheel Pop Up Tutorial',
            titleKey: 'tutorials_page.video_spin_wheel_tutorial',
            thumbNailSrc: '/app_assets/video-gallery/fw-thumbnail.png',
            eventName: 'SpinWheel Tutorial',
            cloudflare: {
              link: '',
              id: ''
            }
          },
          {
            id: 'wePo85NHY7Q',
            title: 'Pop up without Reward Tutorial',
            titleKey: 'tutorials_page.video_popup_no_reward_tutorial',
            thumbNailSrc: '/app_assets/video-gallery/bsb-thumbnail.png',
            eventName: 'PopupNoReward Tutorial',
            cloudflare: {
              link: '',
              id: ''
            }
          },
          {
            id: 'GZGpVpGLJLg',
            title: 'Opt-in Pop Up Tutorial',
            titleKey: 'tutorials_page.video_optin_popup_tutorial',
            thumbNailSrc: '/app_assets/video-gallery/bcb-thumbnail.png',
            eventName: 'PopupReward Tutorial',
            cloudflare: {
              link: '',
              id: ''
            }
          },
          {
            id: 'cp2SB-FkaOs',
            title: 'Free Shipping Pop Up Tutorial',
            titleKey: 'tutorials_page.video_free_shipping_popup_tutorial',
            thumbNailSrc: '/app_assets/video-gallery/fsp-thumbnail.png',
            eventName: 'Free Shipping Popup Tutorial',
            cloudflare: {
              link: '',
              id: ''
            }
          },
          {
            id: 'VFrUNN8tyQI',
            title: 'Sales Announcement Pop Up Tutorial',
            titleKey: 'tutorials_page.video_sales_announcement_popup_tutorial',
            thumbNailSrc: '/app_assets/video-gallery/sales-announcement-thumbnail.webp',
            eventName: 'Sales Popup Tutorial',
            cloudflare: {
              link: '',
              id: ''
            }
          },
          {
            id: 'hp0h_JpidII',
            title: 'Product Announcement Pop Up Tutorial',
            titleKey: 'tutorials_page.video_product_announcement_popup_tutorial',
            thumbNailSrc: '/app_assets/video-gallery/product-announcement-thumbnail.webp',
            eventName: 'Product Popup Tutorial',
            cloudflare: {
              link: '',
              id: ''
            }
          },
        ]
      },
      // SOCIAL PROOF NOTIFICATIONS
      {
        title: 'Social Proof Notifications',
        titleKey: 'tutorials_page.playlist_social_proof',
        id: TutorialId.SocialProof,
        thumbNailSrc: '/app_assets/video-gallery/rsp-thumbnail.png',
        videos: [
          {
            id: 'tHP04-CWBXM',
            title: 'Recent Activity Pop Up | Social Proof',
            titleKey: 'tutorials_page.video_recent_activity_social_proof',
            thumbNailSrc: '/app_assets/video-gallery/rsp-thumbnail.png',
            eventName: 'RecentActivity Tutorial',
            cloudflare: {
              link: '',
              id: ''
            }
          },
        ]
      },
      // AB TESTING
      {
        title: 'A/B Testing',
        titleKey: 'tutorials_page.playlist_ab_testing',
        id: TutorialId.AbTesting,
        thumbNailSrc: '/app_assets/video-gallery/upsell-thumbnail.png',
        videos: [
          {
            id: '',
            title: 'How To Create an A/B Test',
            titleKey: 'tutorials_page.video_ab_how_to_create',
            thumbNailSrc: '/app_assets/video-gallery/email-thumbnail.jpg',
            eventName: 'A/B Testing Tutorial',
            cloudflare: {
              link: '',
              id: 'a06ef87d57a43b46bb37ebb64a1dd5ef'
            }
          },
          {
            id: '',
            title: 'Increase Your Conversion Rates',
            titleKey: 'tutorials_page.video_increase_conversion_rates',
            thumbNailSrc: '/app_assets/video-gallery/email-thumbnail.jpg',
            eventName: 'Increase Conversion Tutorial',
            cloudflare: {
              link: '',
              id: '8dd06157354f98c498c7a2f377185ff7'
            }
          },
        ]
      },
      // ONE CLICK UPSELL
      {
        title: 'One Click Upsell',
        titleKey: 'tutorials_page.playlist_one_click_upsell',
        id: TutorialId.Upsell,
        thumbNailSrc: '/app_assets/video-gallery/upsell-thumbnail.png',
        videos: [
          {
            id: 'WZYrIeaZpcY',
            title: 'One-Click Upsell Tutorial',
            titleKey: 'tutorials_page.video_one_click_upsell_tutorial',
            thumbNailSrc: '/app_assets/video-gallery/upsell-thumbnail.png',
            eventName: 'OneClickUpsell Tutorial',
            cloudflare: {
              link: '',
              id: ''
            }
          },
        ]
      },
      // EMAIL
      {
        title: 'Email',
        titleKey: 'tutorials_page.playlist_email',
        id: TutorialId.Email,
        thumbNailSrc: '/app_assets/video-gallery/email-thumbnail.jpg',
        videos: [
          {
            id: 'RMdXZeiOynQ',
            title: 'Email Overview',
            titleKey: 'tutorials_page.video_email_overview',
            thumbNailSrc: '/app_assets/video-gallery/email-thumbnail.jpg',
            eventName: 'Email Overview',
            cloudflare: {
              link: '',
              id: ''
            }
          },
        ]
      },
      // OTHER TUTORIALS
      {
        title: 'Other Tutorials',
        titleKey: 'tutorials_page.playlist_other',
        id: TutorialId.Other,
        thumbNailSrc: '/app_assets/video-gallery/upsell-thumbnail.png',
        videos: [
          {
            id: 'VgE7nM0r5dM',
            title: 'Overview',
            titleKey: 'tutorials_page.video_overview',
            thumbNailSrc: '/app_assets/video-gallery/welcome-thumbnail.png',
            eventName: 'Overview',
            cloudflare: {
              id: '920e4956af7429ce4ceab750ddc71e54',
              link: 'https://customer-x07oc7fhgs0miebp.cloudflarestream.com/920e4956af7429ce4ceab750ddc71e54/iframe?poster=https%3A%2F%2Fcustomer-x07oc7fhgs0miebp.cloudflarestream.com%2F920e4956af7429ce4ceab750ddc71e54%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600'
            }
          },
        ]
      },
    ],
  }

  constructor() {}

  public getVideoById(id: string): TutorialVideoItem {
    for (const playlist of this.library.playlists) {
      for (const video of playlist.videos) {
        if (video.id === id) {
          return {
            parentID: playlist.id,
            ...video
          }
        }
        if (video.cloudflare.id === id) {
          return {
            parentID: playlist.id,
            ...video
          }
        }
      }
    }
  }
}
